import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TreoMessage } from '@treo/components/message';

@Component({
  selector: 'ew-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {
  @Input() open: boolean = false;
  @Input() title: string = 'Title';
  @Input() message: TreoMessage | null = null;

  @Output() close: EventEmitter<any> = new EventEmitter();

  /**
   * validates the type for content
   * @param value {message.content} type of content
   * @author Martin Batun Tec.
   */
  getContentType(value: any): string {
    if (Array.isArray(value)) {
      return 'array';
    } else if (typeof value === 'string') {
      return 'string';
    } else {
      return 'other';
    }
  }
}
